import { initContract } from '@ts-rest/core';
import { accountingPeriodsContract } from './accounting-periods.js';
import { accountsContract } from './accounts.js';
import { auditContract } from './audit.js';
import { authContract } from './auth.js';
import { creditNotesContract } from './credit-notes.js';
import { deliveryNotesContract } from './delivery-notes.js';
import { goodsReceiptsContract } from './goods-receipts.js';
import { healthContract } from './health.js';
import { itemCategoriesContract } from './item-categories.js';
import { itemsContract } from './items.js';
import { journalsContract } from './journals.js';
import { leadsContract } from './leads.js';
import { opportunitiesContract } from './opportunities.js';
import { partnersContract } from './partners.js';
import { paymentsContract } from './payments.js';
import { legalEntitiesContract } from './legal-entities.js';
import { manufacturersContract } from './manufacturers.js';
import { partnerGroupsContract } from './partner-groups.js';
import { paymentTermsContract } from './payment-terms.js';
import { priceTiersContract } from './price-tiers.js';
import { purchaseInvoicesContract } from './purchase-invoices.js';
import { purchaseReturnsContract } from './purchase-returns.js';
import { purchaseOrdersContract } from './purchase-orders.js';
import { quotationsContract } from './quotations.js';
import { receiptsContract } from './receipts.js';
import { rolesContract } from './roles.js';
import { invoicesContract } from './sales-invoices.js';
import { searchContract } from './search.js';
import { salesOrdersContract } from './sales-orders.js';
import { stockContract } from './stock.js';
import { stockAdjustmentsContract } from './stock-adjustments.js';
import { stockCountsContract } from './stock-counts.js';
import { stockTransfersContract } from './stock-transfers.js';
import { tasksContract } from './tasks.js';
import { orgSettingsContract } from './org-settings.js';
import { unitGroupsContract } from './unit-groups.js';
import { unitsContract } from './units.js';
import { usersContract } from './users.js';
import { bankingContract } from './banking.js';
import { projectsContract } from './projects.js';
import { projectTasksContract } from './project-tasks.js';
import { timesheetsContract } from './timesheets.js';
import { projectBillingContract } from './project-billing.js';
import { warehousesContract } from './warehouses.js';
import { fxContract } from './fx.js';
import { fixedAssetsContract } from './fixed-assets.js';
import { einvoicingContract } from './einvoicing.js';
import { hrContract } from './hr.js';
import { attendanceContract } from './attendance.js';
import { leaveContract } from './leave.js';
import { payrollContract } from './payroll.js';
import { recruitmentContract } from './recruitment.js';
import { dashboardsContract } from './dashboards.js';
import { reportsContract } from './reports.js';
import { posContract } from './pos.js';
import { importsContract } from './imports.js';
import { documentsContract } from './documents.js';
import { bomContract } from './bom.js';
import { workOrdersContract } from './work-orders.js';
import { productionPlanningContract } from './production-planning.js';
import { materialConsumptionContract } from './material-consumption.js';
import { notificationsContract } from './notifications.js';
import { subscriptionContract } from './subscription.js';
import { dataTransferContract } from './data-transfer.js';
import { apiKeysContract } from './api-keys.js';
import { numberSequencesContract } from './number-sequences.js';
import { favoritesContract } from './favorites.js';
import { attachmentsContract } from './attachments.js';
import { reorderContract } from './reorder.js';
export * from './accounting-periods.js';
export * from './accounts.js';
export * from './audit.js';
export * from './auth.js';
export * from './health.js';
export * from './permissions.js';
export * from './document-navigation.js';
export * from './document-stats.js';
export * from './pagination.js';
export * from './primitives.js';
export * from './roles.js';
export * from './partners.js';
export * from './sales-invoices.js';
export * from './search.js';
export * from './receipts.js';
export * from './tenders.js';
export * from './unit-groups.js';
export * from './units.js';
export * from './legal-entities.js';
export * from './manufacturers.js';
export * from './partner-groups.js';
export * from './payment-terms.js';
export * from './price-tiers.js';
export * from './item-categories.js';
export * from './items.js';
export * from './journals.js';
export * from './purchase-orders.js';
export * from './purchase-invoices.js';
export * from './purchase-returns.js';
export * from './payments.js';
export * from './quotations.js';
export * from './sales-orders.js';
export * from './credit-notes.js';
export * from './warehouses.js';
export * from './stock.js';
export * from './stock-adjustments.js';
export * from './stock-counts.js';
export * from './stock-transfers.js';
export * from './goods-receipts.js';
export * from './delivery-notes.js';
export * from './org-settings.js';
export * from './company-clock.js';
export * from './users.js';
export * from './leads.js';
export * from './opportunities.js';
export * from './tasks.js';
export * from './banking.js';
export * from './hr.js';
export * from './attendance.js';
export * from './leave.js';
export * from './payroll.js';
export * from './recruitment.js';
export * from './projects.js';
export * from './project-tasks.js';
export * from './timesheets.js';
export * from './project-billing.js';
export * from './dashboards.js';
export * from './reports.js';
export * from './fx.js';
export * from './fixed-assets.js';
export * from './einvoicing.js';
export * from './email.js';
export * from './billing.js';
export * from './ops.js';
export * from './pos.js';
export * from './imports.js';
export * from './documents.js';
export * from './manufacturing.js';
export * from './bom.js';
export * from './work-orders.js';
export * from './production-planning.js';
export * from './material-consumption.js';
// PART 15 ADM-04 — the bell.
export * from './notifications.js';
// PART 15 ADM-07 — the customer's read-only view of what they bought.
export * from './subscription.js';
// PART 15 ADM-03 — the Import / Export Centre.
export * from './data-transfer.js';
// PART 15 ADM-02 — integrations (reported) and API keys (real).
export * from './api-keys.js';
// PART 5 MD-13 — the numbering record and the screen that edits it.
export * from './number-sequences.js';
// G-01 — the person's own favourites bar (the star in the top bar).
export * from './favorites.js';
export * from './attachments.js';
// Wave 5A — reorder suggestions → a draft purchase order (PUR-01's draft).
export * from './reorder.js';
const c = initContract();
/**
 * ── Why `satisfies` and not just the annotation ─────────────────────────────
 *
 * `export const contract: ContractRouter = c.router({ … })` type-checks a
 * MISSING module — but it does NOT catch an EXTRA one. `c.router()` returns a
 * value rather than a fresh object literal, so excess-property checking never
 * runs on it, and a module added to the router but forgotten in
 * `ContractRouter` is silently dropped from the public type: the route exists
 * at runtime, answers requests, and is invisible to every generated client.
 * That is a worse failure than a build error, because nothing anywhere says so.
 *
 * Applying `satisfies` to the OBJECT LITERAL is what closes it. A literal does
 * get excess-property checking, so an unlisted key fails here, and assignability
 * still catches a missing one. Both directions, at the only place that can see
 * both.
 */
const routes = {
    health: healthContract,
    auth: authContract,
    audit: auditContract,
    roles: rolesContract,
    partners: partnersContract,
    invoices: invoicesContract,
    quotations: quotationsContract,
    salesOrders: salesOrdersContract,
    creditNotes: creditNotesContract,
    receipts: receiptsContract,
    accounts: accountsContract,
    journals: journalsContract,
    // Q-FIN-01-3 — the period table posting checks everywhere (GEN-92/-93/-94).
    accountingPeriods: accountingPeriodsContract,
    numberSequences: numberSequencesContract,
    units: unitsContract,
    unitGroups: unitGroupsContract,
    priceTiers: priceTiersContract,
    paymentTerms: paymentTermsContract,
    partnerGroups: partnerGroupsContract,
    legalEntities: legalEntitiesContract,
    manufacturers: manufacturersContract,
    itemCategories: itemCategoriesContract,
    items: itemsContract,
    purchaseOrders: purchaseOrdersContract,
    reorder: reorderContract,
    purchaseInvoices: purchaseInvoicesContract,
    purchaseReturns: purchaseReturnsContract,
    payments: paymentsContract,
    warehouses: warehousesContract,
    stock: stockContract,
    stockAdjustments: stockAdjustmentsContract,
    stockCounts: stockCountsContract,
    stockTransfers: stockTransfersContract,
    goodsReceipts: goodsReceiptsContract,
    deliveryNotes: deliveryNotesContract,
    orgSettings: orgSettingsContract,
    users: usersContract,
    leads: leadsContract,
    opportunities: opportunitiesContract,
    tasks: tasksContract,
    banking: bankingContract,
    hr: hrContract,
    attendance: attendanceContract,
    leave: leaveContract,
    payroll: payrollContract,
    recruitment: recruitmentContract,
    projects: projectsContract,
    projectTasks: projectTasksContract,
    timesheets: timesheetsContract,
    projectBilling: projectBillingContract,
    dashboards: dashboardsContract,
    reports: reportsContract,
    fx: fxContract,
    fixedAssets: fixedAssetsContract,
    einvoicing: einvoicingContract,
    // PART 6 SAL-06 (the till) and PART 7 PUR-06 (import orders).
    pos: posContract,
    imports: importsContract,
    // DECISION.md §2.13 — ask for a PDF, poll it, download it. The rendering
    // itself is a job, so no route here ever waits on Chromium.
    documents: documentsContract,
    // PART 9 — the four manufacturing screens. Every route is gated on the
    // `manufacturing` paid module at the controller (BR-OPS-02-04) and on the
    // `manufacturing` permission area (PART 16.2.2 row 4).
    boms: bomContract,
    workOrders: workOrdersContract,
    productionPlanning: productionPlanningContract,
    materialConsumption: materialConsumptionContract,
    notifications: notificationsContract,
    subscription: subscriptionContract,
    dataTransfer: dataTransferContract,
    apiKeys: apiKeysContract,
    search: searchContract,
    favorites: favoritesContract,
    // INV-H5 / IT-S8 — files on documents and master records.
    attachments: attachmentsContract,
};
export const contract = c.router(routes);
//# sourceMappingURL=index.js.map